import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

// export default new Vuetify({
//   theme: { dark: true }
// });

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      dark: {
        //** */ default colours:
        // primary: '#1976D2',
        // secondary: '#424242',
        // accent: '#82B1FF',
        // error: '#FF5252',
        // info: '#2196F3',
        // success: '#4CAF50',
        // warning: '#FFC107',
        primary: '#0177FB',
        offWhite: '#E1EAFF',
        cardIsland: '#2C2D3A', 
        cardIslandLighter: '#353546', 
        background: '#1A1B23', // not used. In App.vue manually
        backgroundLighter: '#23242F',
      },
    },
  },
})
